import { withMeetingAndEventBasedMarketTemplateModelState } from '@swf/sports/models/market-templates/meetingAndEventBased';

import type { SportsHomePageState } from './types';

export const defaultState = withMeetingAndEventBasedMarketTemplateModelState<SportsHomePageState>({
  isLoading: false,
  hasPreloaded: false,
  eventTypes: {},
  events: {},
  competitions: {},
  meetings: {},
  races: {},
  markets: {},
  popularBetBuilders: [],
  popularAccumulators: [],
  oddsBoosts: [],
  inPlayEvents: [],
  popularSports: [],
  upcomingEvents: [],
  components: []
});
